import { render, staticRenderFns } from "./CursoView.vue?vue&type=template&id=7c978046&scoped=true"
import script from "./CursoView.vue?vue&type=script&lang=js"
export * from "./CursoView.vue?vue&type=script&lang=js"
import style0 from "./CursoView.vue?vue&type=style&index=0&id=7c978046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c978046",
  null
  
)

export default component.exports